import { GLASS_SURFACE, Skeleton } from '../../../../modules/design-system';

/**
 * Loading state for PackInfoCard — mirrors the real card's outer
 * footprint, padding and tier-row height so the layout doesn't shift.
 */
export function PackInfoCardSkeleton() {
  return (
    <div
      className={
        GLASS_SURFACE +
        ' relative overflow-hidden rounded-[28px] border-2'
      }
      aria-busy
    >
      <div className="flex flex-col items-center gap-2 pt-[22px] px-[14px]">
        {/* title */}
        <Skeleton className="h-[28px] w-[70%] rounded-[6px]" />
        {/* subtitle 2 lines */}
        <Skeleton className="mt-1 h-[14px] w-[80%] rounded-[4px]" />
        <Skeleton className="h-[14px] w-[60%] rounded-[4px]" />
      </div>

      {/* Tier row — 3 tier-card placeholders */}
      <div className="pt-4 px-[14px] pb-[14px]">
        <div className="flex items-center gap-2 overflow-hidden">
          {Array.from({ length: 3 }).map((_, i) => (
            <Skeleton
              key={i}
              className="
                shrink-0 rounded-[16px]
                h-[52px] w-[121px]
                @[900px]:h-[100px] @[900px]:w-[119px] @[900px]:rounded-[20px]
              "
            />
          ))}
        </div>
      </div>
    </div>
  );
}
